import { useEffect } from 'react';

const LiveChat = () => {
  useEffect(() => {
    // Tawk.to Live Chat Widget
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/5e8b8a6f35bcbb0c9ab195bb/default';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const tawkScript = document.querySelector('script[src*="tawk.to"]');
      if (tawkScript) {
        document.body.removeChild(tawkScript);
      }
    };
  }, []);

  return null;
};

export default LiveChat;